import { createAction, createAsyncAction } from 'typesafe-actions'
import { CurrentUser, CurrentUserUpdateData } from '../../../responses/users'

export const userActions = {
    reload: createAction('@USER/RELOAD')(),
    refreshToken: createAsyncAction(
        '@USER/REFRESH_TOKEN_REQUEST',
        '@USER/REFRESH_TOKEN_SUCCESS',
        '@USER/REFRESH_TOKEN_FAILURE',
    )<undefined, string, void>(),
    logout: createAsyncAction(
        '@USER/LOGOUT_REQUEST',
        '@USER/LOGOUT_SUCCESS',
        '@USER/LOGOUT_FAILURE',
    )<undefined, undefined, void>(),
    update: createAsyncAction(
        '@USER/UPDATE_REQUEST',
        '@USER/UPDATE_SUCCESS',
        '@USER/UPDATE_FAILURE',
    )<CurrentUserUpdateData, CurrentUser, void>(),
    login: createAsyncAction(
        '@USER/LOGIN_REQUEST',
        '@USER/LOGIN_SUCCESS',
        '@USER/LOGIN_FAILURE',
    )<{ login: string, password: string }, string, void>(),
    info: createAsyncAction(
        '@USER/INFO_REQUEST',
        '@USER/INFO_SUCCESS',
        '@USER/INFO_FAILURE',
    )<undefined, CurrentUser, void>()
}